export default "__VITE_ASSET__DA5tRJbz__"